import { authFetch } from './api';

function clearToken() {
  localStorage.removeItem('auth_token');
}

async function json(res) {
  if (res.status === 401) {
    clearToken();
    throw new Error('Session expired. Please login again.');
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    const detail = err.detail;
    throw new Error(typeof detail === 'string' ? detail : (detail ? JSON.stringify(detail) : 'Request failed'));
  }
  return res.json();
}

export const settingsService = {
  getMe: () => authFetch('/api/user/me').then(json),
  getJobs: () => authFetch('/api/jobs').then(json),
  getIntegrations: () => authFetch('/api/user/integrations/status').then(json),
  getPreferences: () => authFetch('/api/user/preferences').then(json),
  savePreferences: (prefs) =>
    authFetch('/api/user/preferences', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(prefs),
    }).then(json),
  changePassword: (payload) =>
    authFetch('/auth/change-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(json),
  connectIntegration: (provider, token) =>
    authFetch(`/api/user/integrations/${provider}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    }).then(json),
  disconnectIntegration: (provider) =>
    authFetch(`/api/user/integrations/${provider}`, { method: 'DELETE' }).then(json),
  deleteAccount: () => authFetch('/api/user', { method: 'DELETE' }).then(json),
};

/** Map preference label to StackSelector stack id */
export const PREF_TO_STACK = {
  React: 'react-node',
  Vue: 'vue-node',
  Angular: 'angular-node',
  Node: 'react-node',
  Python: 'react-python',
};

export function stackFromPreference(pref) {
  return PREF_TO_STACK[pref] || 'react-node';
}
